module.exports = __webpack_public_path__ + "static/media/clients.276b45f7.svg";